import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef8943da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "success-close-container" }
const _hoisted_2 = { class: "success-content" }
const _hoisted_3 = { class: "success-title" }
const _hoisted_4 = { class: "success-desc" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "success-character" }
const _hoisted_7 = { class: "success-deatil-container" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "success-deatil-value-container" }
const _hoisted_10 = { class: "success-detail-label" }
const _hoisted_11 = { class: "success-detail-value" }
const _hoisted_12 = { class: "success-detail-label" }
const _hoisted_13 = { class: "success-detail-value" }
const _hoisted_14 = { class: "success-detail-label" }
const _hoisted_15 = { class: "success-detail-value" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = {
  key: 1,
  class: "success-loading"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading h-10 w-10 mx-auto" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: _ctx.successModalOpen,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSuccessModalOpen(false))),
    rounded: "top-left-to-bottom-right",
    bgColor: "white",
    width: "xl"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_BalIcon, {
          class: "success-close",
          name: "entypo:circle-with-cross",
          size: "lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSuccessModalOpen(false)))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('congratulations').toUpperCase()), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('you_successfully_minted_and_own').toUpperCase()), 1),
        (_ctx.newNft && !_ctx.loadingNewNft)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.newNft.character || ''), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.newNft.image,
                  class: "success-detail-image"
                }, null, 8, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('name').toUpperCase()) + ":", 1),
                    _createElementVNode("span", _hoisted_11, _toDisplayString((_ctx.newNft.character || '').toUpperCase()), 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('price').toUpperCase()) + ":", 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.newNft.price) + " ACSI", 1)
                  ]),
                  _createElementVNode("p", null, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('nft')) + " #:", 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.newNft.id), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_BalBtn, {
                  rounded: "",
                  color: "red",
                  size: "md",
                  class: "success-ok",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSuccessModalOpen(false)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('ok')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}